import { Link } from "react-router-dom";
import { PROJECTS } from "../../data/projects";

const FEATURED = PROJECTS.slice(0, 6);

export const FeaturedProjects = () => (
    <section id="projects" className="py-20 md:py-28 bg-white">
        <div className="container-px mx-auto max-w-7xl">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
                <div className="max-w-2xl">
                    <p className="text-sm font-semibold text-navy-600 uppercase tracking-[0.2em] mb-4">Featured work</p>
                    <h2 className="text-display-lg font-display text-navy-900 mb-4">
                        Built across the western U.S.
                    </h2>
                    <p className="text-lg text-steel-600">
                        A sample of recent projects detailed and modeled in SDS2 — from university research buildings to museums and zoo exhibits.
                    </p>
                </div>
                <Link
                    to="/projects"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy-700 no-underline hover:text-navy-600 hover:gap-2.5 transition-all shrink-0"
                >
                    View all projects
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {FEATURED.map((project) => (
                    <article
                        key={project.slug}
                        className="group relative overflow-hidden rounded-xl bg-navy-900 aspect-[4/3]"
                    >
                        <img
                            src={project.image}
                            alt={project.title}
                            loading="lazy"
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-900/40 to-transparent opacity-90" />

                        <div className="absolute top-4 left-4">
                            <span className="inline-block px-2.5 py-1 rounded-md bg-white/10 backdrop-blur-sm border border-white/20 text-[10px] font-semibold text-white uppercase tracking-wider">
                                {project.category}
                            </span>
                        </div>

                        <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                            <h3 className="text-lg font-bold font-display mb-1 leading-snug">{project.title}</h3>
                            <p className="text-sm text-steel-200 m-0">{project.location}</p>
                        </div>
                    </article>
                ))}
            </div>

            <div className="mt-12 text-center">
                <Link
                    to="/projects"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-navy-700 text-navy-700 font-semibold no-underline hover:bg-navy-700 hover:text-white transition-all"
                >
                    See all projects
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </Link>
            </div>
        </div>
    </section>
);
